import { FC } from 'react'

import { nanoid } from 'nanoid'

import { IRange } from 'widgets/tour/date-range-picker'

import { Month } from './components/month'
import { DaysOfWeek } from './components/month/days/model'
import {
  DateInfo,
  MONTH_NUMBER,
  SelectedDaysDifficult,
} from './components/month/model/model'
import { renderMonth } from './components/month/model/render-month'
import { DisabledDay, InfoDay, SelectedDay } from './lib'
import s from './styles.module.scss'

const MAX_MONTH = 18

const ONE_MONTH = 1

const ONE_DAY = 1

const ONE_YEAR = 1

const MONTH_FINISH = 13

const DAY_SUNDAY = {
  check: 0, // sunday check
  value: 6, // sunday change
}

const getCurrentMonthStart = (year: number, month: number) => {
  let currentDayOfWeek = new Date(`${year}/${month}/1`).getDay() - ONE_DAY

  if (currentDayOfWeek < DAY_SUNDAY.check) {
    currentDayOfWeek = DAY_SUNDAY.value
  }

  return currentDayOfWeek
}

interface Props {
  dateInfo?: DateInfo[]
  activeDays?: string[]
  selectedDays?: SelectedDaysDifficult[]
  isDifficult?: boolean
  selected: IRange | null
  indexDirection?: number
  isExcursion?: boolean
  isFlexibleDeparture?: boolean
  maxMonth?: number
  maxRangeDays?: number
  onClick: (day: string) => void
}

export const MonthWrapper: FC<Props> = ({
  dateInfo,
  activeDays,
  selectedDays,
  selected,
  isExcursion,
  indexDirection,
  isFlexibleDeparture,
  onClick,
  maxMonth = MAX_MONTH,
  maxRangeDays,
}) => {
  const currentDate = new Date()

  let year = currentDate.getFullYear()
  let month = currentDate.getMonth()

  const getCurrentDayInfo = InfoDay(dateInfo)

  const getDisabledDayInfo = DisabledDay(activeDays, isExcursion)

  const getAlreadySelectedDays = SelectedDay(indexDirection || 0, selectedDays)

  return (
    <div className={s.container}>
      {[...Array(maxMonth)].map(() => {
        month += ONE_MONTH

        if (month === MONTH_FINISH) {
          month = ONE_MONTH
          year += ONE_YEAR
        }

        const startDayInMonth = getCurrentMonthStart(year, month)

        const listDays = renderMonth({
          year,
          selected,
          isExcursion,
          month: month as MONTH_NUMBER,
          hasActiveDays: !!activeDays?.length,
          hasSelectedDays: !!selectedDays?.length,
          isFlexibleDeparture,
          getCurrentDayInfo,
          getDisabledDayInfo,
          getAlreadySelectedDays,
          maxRangeDays,
        })

        return (
          <Month
            year={year}
            month={month}
            date={listDays}
            monthStart={startDayInMonth as DaysOfWeek}
            onClick={onClick}
            key={nanoid()}
          />
        )
      })}
    </div>
  )
}
